import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import { IoChevronBackCircleOutline } from "react-icons/io5";
import instance from "../../api/api";
// import Input from "../../features/Input";
// import Button from "../../features/Button";
// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";
// import Spinner from "react-bootstrap/Spinner";
// import Table from "react-bootstrap/Table";
// import { Tabs } from "antd-mobile";
import { useSelector, useDispatch } from "react-redux";
import { tooglePrint } from "../../store/slice/PrintSlice";
import { IoPrint } from "react-icons/io5";
import { Help, statusConfig } from "../../utils";
import { useReactToPrint } from "react-to-print";
import "./Invoice.css";
// import { PaiementDatatable } from "../Paiements/ListerPaiement";
import { Header, LoadingSpinner, InfoDetails } from "../../shared/compoments";

const PrintComponent = ({
  invoiceClient,
  invoiceReference,
  invoicePeriode,
  invoiceType,
  invoiceMontant,
}) => {
  const printRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  const invoiceDataPrint = [
    {
      clientName: invoiceClient,
      invoiceNumber: invoiceReference,
      invoicePeriode: `${invoicePeriode.date_debut} au ${invoicePeriode.date_fin}`,
      invoiceMontant: invoiceMontant,
      invoiceType: invoiceType,
      properties: [
        {
          description: "Appartement de 3 pièces au centre-ville",
          rentalPeriod: "2024-08-01 au 2024-08-31",
          dailyRate: 100,
          days: 31,
        },
        {
          description: "Maison de campagne avec jardin",
          rentalPeriod: "2024-07-15 au 2024-07-31",
          dailyRate: 150,
          days: 17,
        },
      ],
    },
    {
      clientName: invoiceClient,
      invoiceNumber: invoiceReference,
      invoicePeriode: `${invoicePeriode.date_debut} au ${invoicePeriode.date_fin}`,
      invoiceMontant: invoiceMontant,
      invoiceType: invoiceType,
      properties: [
        {
          description: "Appartement de 3 pièces au centre-ville",
          rentalPeriod: "2024-08-01 au 2024-08-31",
          dailyRate: 100,
          days: 31,
        },
        {
          description: "Maison de campagne avec jardin",
          rentalPeriod: "2024-07-15 au 2024-07-31",
          dailyRate: 150,
          days: 17,
        },
      ],
    },
  ];

  // const calculateTotal = () => {
  //   return invoiceData.properties.reduce((total, item) => total + item.quantity * item.price, 0);
  // };
  const dispatch = useDispatch();

  return (
    <div>
      <div className="invoice-container_one">
        <div className="invoice-container" ref={printRef} id="print-section">
          <header>
            <h1>Facture</h1>
            {/* <div className="company-info">
          <h2>{invoiceData.companyName}</h2>
        </div> */}
          </header>
          <hr />
          {invoiceDataPrint.map((item, index) => (
            <>
              <div key={index}>
                <section className="client-info">
                  <p>
                    <strong>Client:</strong> {item?.clientName}
                  </p>
                </section>
                <section className="invoice-details">
                  <p>
                    <strong>Numéro de Facture:</strong> {item?.invoiceNumber}
                  </p>
                  <p>
                    <strong>Période:</strong> {item?.invoicePeriode}
                  </p>
                  <p>
                    <strong>Type :</strong> {item?.invoiceType}
                  </p>
                  <p>
                    <strong>Montant :</strong>{" "}
                    {Help.convertInMoney(item?.invoiceMontant)} Fcfa
                  </p>
                </section>
                {/* <table className="invoice-table">
        <thead>
          <tr>
            <th>Description de la Propriété</th>
            <th>Période</th>
            <th>Tarif Journalier</th>
            <th>Jours</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {item.invoiceData.properties.map((property, index) => (
            <tr key={index}>
              <td>{property.description}</td>
              <td>{property.rentalPeriod}</td>
              <td>{property.dailyRate.toFixed(2)} €</td>
              <td>{property.days}</td>
              <td>{(property.days * property.dailyRate).toFixed(2)} €</td>
            </tr>
          ))}
        </tbody>
      </table> */}

                {/* <footer>
        <p><strong>Total à Payer: </strong>{calculateTotal().toFixed(2)} €</p>
      </footer> */}
                <div className="info-signature">
                  <p>Signature du client:</p>
                  <p>Signature de l'Entreprise:</p>
                </div>
              </div>
              <hr />
            </>
          ))}
        </div>
      </div>
      <div className="info-btn">
        <button
          onClick={() => {
            handlePrint();
            dispatch(tooglePrint());
          }}
          className="btn bg-primary my-3 text-light">
          Imprimer
        </button>
        <button
          className="btn bg-danger my-3 text-light"
          onClick={() => dispatch(tooglePrint())}>
          Fermer
        </button>
      </div>
    </div>
  );
};

export const DetailsFactures = ({
  detailDate,
  detailReference,
  detailPeriode,
  detailMontant,
  detailType,
  detailStatut,
  showPrint,
}) => {
  const dispatch = useDispatch();
  return (
    <div className="conteneur_contrat">
      <div className="contrat">
        <span className="badge bg-info">Détails de la facture</span>
      </div>
      <div className="d-flex justify-content-between gap-3">
        <div>
          <p>
            <span className="fw-bold text-secondary">Date d'Emission :</span>{" "}
            <br />
            <span>{new Date(detailDate).toLocaleDateString("fr")}</span>
          </p>
          <p>
            <span className="fw-bold text-secondary">
              Numéro de la facture :
            </span>{" "}
            <br />
            <span>{detailReference}</span>
          </p>
          <p>
            <span className="fw-bold text-secondary">Période du loyer:</span>{" "}
            <br />
            {detailPeriode?.date_debut} au {detailPeriode?.date_fin}
          </p>
          <p>
            <span className="fw-bold text-secondary">Montant :</span> <br />
            <span> {Help.convertInMoney(detailMontant)} </span>
          </p>
          <p>
            <span className="fw-bold text-secondary">Type :</span> <br />
            <span> {detailType} </span>
          </p>
        </div>

        <div>
          <span
            className="badge"
            style={{
              background: statusConfig[detailStatut],
            }}>
            {detailStatut}
          </span>
          {showPrint && (
            <div className="text-center">
              <IoPrint
                fontSize={"2em"}
                style={{ cursor: "pointer" }}
                onClick={() => dispatch(tooglePrint())}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const DetailClient = ({
  detailClient: {
    client: { nom, prenom, email, phone },
  },
  detailReference,
  detailPeriode,
  detailType,
  detailMontant,
}) => {
  const isPrint = useSelector((state) => state.print.isPrint);

  return (
    <div className="conteneur_contrat">
      <div className="contrat">
        <span className="badge bg-primary">Informations sur le client</span>
      </div>
      <div className="d-flex justify-content-between gap-3">
        <div>
          <p>
            <span className="fw-bold text-secondary">Client :</span> <br />
            <span>
              {nom} {prenom}
            </span>
          </p>
          <p>
            <span className="fw-bold text-secondary">Email :</span> <br />
            {email}
          </p>
          <p>
            <span className="fw-bold text-secondary">Contact :</span> <br />
            {phone}
          </p>

          {isPrint && (
            <div
              style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                background: "#00000069",
                display: "flex",
                justifyContent: "center",
                placeItems: "center",
                zIndex: "9999",
              }}>
              <PrintComponent
                invoiceClient={`${nom} ${" "} ${prenom}`}
                invoiceReference={detailReference}
                invoicePeriode={detailPeriode}
                invoiceType={detailType}
                invoiceMontant={detailMontant}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

function FacturesDetail() {
  // const MySwal = withReactContent(Swal);
  const navigate = useNavigate();
  const { id } = useParams();
  const [detailFactures, setDetailFactures] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [detailInfo, setDetailInfo] = useState([]);
  const DATA_BTN_WITH_CONTRAT_OPTIONS = [
    {
      titleBtn: "Voir les paiements",
      // icone: <GrGallery />,
      isColor: false,
      isVisible: true,
      methode: () => {
        navigate("/factures/paiement/" + id);
      },
    },
  ];
  const dataInfoDetail = (created_at, date_debut, date_fin, cost, statut) => {
    const element = [];
    element.push(
      { title: "STATUT", value: statut },
      {
        title: "DATE D'EMISSION",
        value: new Date(created_at).toLocaleDateString("fr"),
      },
      {
        title: "PÉRIODE DU LOYER",
        value: date_debut ? `${date_debut} au ${date_fin}` : "Néant",
      },
      { title: "MONTANT", value: Number(cost) }
      // { title: "MOYEN PAIEMENT", value: municipality.name },
      // { title: "CATEGORIE DE BIEN", value: type.category.label },
      // { title: "NOMBRE DE PIECE", value: nombre_pieces },
      // { title: "NOMBRE DE PORTES", value: nombre_portes },
      // { title: "CAUTION", value: caution },
      // { title: "DESCRIPTION", value: description }
    );
    setDetailInfo(element);
    console.log("detailInfo85", detailInfo);
  };

  useEffect(() => {
    const getFacturesDetail = async () => {
      try {
        const response = await instance.get(`factures/${id}`);
        console.log(response);
        const { created_at, date_debut, date_fin, cost, statut } =
          response.data.data;
        dataInfoDetail(created_at, date_debut, date_fin, cost, statut);
        setDetailFactures(response.data.data);
        setIsLoading(false);
      } catch (error) {
        console.error("Une erreur s'est produite : ", error);
        setIsLoading(false);
      }
    };
    getFacturesDetail();
  }, [id]);
  //   const handleSubmit = async (e) => {
  //     e.preventDefault();
  //     // setIsLoading(true);
  //     try {
  //       const response = await instance.put(`factures/${id}`,data);
  //       console.log(response);
  //       if (!response.data.status) {
  //         // setIsLoading(false);
  //         MySwal.fire({
  //           title: "Erreur.",
  //           icon: "info",
  //           showConfirmButton: true,
  //         });
  //       }
  //       MySwal.fire({
  //         title: "Modification effectuée avec succès.",
  //         icon: "success",
  //  showConfirmButton: true,
  //       });
  //       // setIsLoading(false);
  //     } catch (error) {
  //       console.log(error);
  //       // setIsLoading(false);
  //       MySwal.fire({
  //         title: error.data.message,
  //         icon: "success",
  //  showConfirmButton: true,
  //       });
  //     }
  //   };
  if (isLoading) return <LoadingSpinner />;
  return (
    <div>
      <Header libelle={"Détails de la facture"} isReturn />

      <InfoDetails
        namePerson={`${detailFactures?.contract.client.nom} ${detailFactures?.contract.client.prenom}`}
        detailPhone={detailFactures?.contract.client.phone}
        detailAdresse={detailFactures?.contract.client.adresse}
        detailEmail={detailFactures?.contract.client.email}
        titleInfo={`Facture ${detailFactures.reference}`}
        widthBody={"63%"}
        dataInfo={detailInfo}
        dataBtnWithOptions={
          detailFactures?.payments.length > 0
            ? DATA_BTN_WITH_CONTRAT_OPTIONS
            : []
        }
      />
    </div>
  );
}

// function GetPersonnel(props) {
//   const {agence} = props
//   const personnel = []

//   for(const item in agence){
//     if((item === "assistant_comptable"
//     || item === "responsable_agences"
//     || item === "supervisers") && agence[item] !== null){
//       console.log(agence[item])
//       personnel.push(agence[item])
//     }
//     if(item === "supervisers" && agence[item] !== null){
//       agence[item].vendeurs.forEach(element => {
//         personnel.push(element)
//        });

//     }
//   }
//   console.log("personnel",personnel)
// //   if(personnel === null) return(
// // <tbody className="text-center">
// //   <tr>
// //     <td colSpan={5}>Pas de donnée.</td>
// //     </tr>
// // </tbody>
// //   );

//     return(
//       <tbody className="text-center">
// {personnel.length > 0 ? (
//                     personnel.map((item) => (
//                       <tr key={item.id}>
//                         <td>{item.lastname}</td>
//                         <td>{item.firstname}</td>
//                         <td>{item.phone1}</td>
//                         <td>{item.email}</td>
//                         <td>{item.role ? item.role.label:null}</td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr className="w-100">
//                       <td colSpan="5" className="text-center">
//                         Pas de donnée.
//                       </td>
//                     </tr>
//                   )}
// </tbody>
//     )
// }

// function GetStock(props) {
//   const {agence} = props
//   const stock = []
//   for(const item in agence){
//     if(item === "responsable_agences" && agence[item] !== null){
//       agence[item].requetes.forEach(element => {
//         if(element.livraison === "Livrer"){
//           stock.push(element)
//         }
//        });

//     }
//   }
//   console.log("stock",stock)

//     return(
//       <tbody className="text-center">

// {stock.length > 0 ? (
//                     stock.map((item) => (
//                       <tr key={item.id}>
//                         <td>{new Date(item.created_at).toLocaleDateString("fr")}</td>
//                         <td className="position-relative">
//                           {Help.calculeTotal(item.produits)}
//                           </td>
//                         <td className="position-relative">
//                           {
//                             item.produits.map(prod=>{
//                               return(
//                                 <span key={prod.id} className="position-absolute span-tableau">{prod.libelle}</span>
//                               )
//                             })
//                           }
//                           </td>

//                         <td className="position-relative">{
//                             item.produits.map(prod=>{
//                               return(
//                                 <span key={prod.id} className="position-absolute span-tableau">{prod.pivot.nombre}</span>
//                               )
//                             })
//                           }</td>
//                         <td className="position-relative">
//                           {
//                             item.produits.map(prod=>{
//                               return(
//                                 <span key={prod.id} className="position-absolute span-tableau">{prod.pivot.nombre_total}</span>
//                               )
//                             })
//                           }</td>

//                           <td className="position-relative">
//                           {
//                             item.produits.map(prod=>{
//                               return(
//                                 <span key={prod.id} className="position-absolute span-tableau">
//                                   {Number(prod.pivot.nombre)-Number(prod.pivot.nombre_total)}</span>
//                               )
//                             })
//                           }
//                           </td>

//                       </tr>
//                     ))

//                   ) : (
//                     <tr className="w-100">
//                       <td colSpan="6" className="text-center">
//                         Pas de donnée.
//                       </td>
//                     </tr>
//                   )}
// </tbody>
//     )
// }

export default FacturesDetail;
